var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_928_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.2197C13.2375 23.2197 14.25 22.2072 14.25 20.9697H9.75C9.75 22.2072 10.7512 23.2197 12 23.2197ZM18.75 16.4697V10.8447C18.75 7.39098 16.905 4.49973 13.6875 3.73473V2.96973C13.6875 2.03598 12.9338 1.28223 12 1.28223C11.0662 1.28223 10.3125 2.03598 10.3125 2.96973V3.73473C7.08375 4.49973 5.25 7.37973 5.25 10.8447V16.4697L3 18.7197V19.8447H21V18.7197L18.75 16.4697Z",
    fill: "#73C7A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_3973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueNotification);
export default __webpack_public_path__ + "static/media/blueNotification.2735b0e1bce4d9d358de0826cd7e2a06.svg";
export { ForwardRef as ReactComponent };